import { useMemo, forwardRef } from 'react'
import { Link } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import * as PropTypes from 'prop-types'
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined'

export default function ListItemLink(props) {
  const { icon, primary, to, onClick } = props

  const renderLink = useMemo(
    () => forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />),
    [to]
  )

  return (
    <li>
      <ListItem dense button component={renderLink} onClick={onClick}>
        {icon ? (
          <ListItemIcon>{icon}</ListItemIcon>
        ) : (
          <ListItemIcon>
            <ImageOutlinedIcon />
          </ListItemIcon>
        )}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  )
}

ListItemLink.propTypes = {
  icon: PropTypes.element,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
}
